/* eslint-disable no-restricted-imports */
import { FC } from 'react';
import { ProductType } from '@/data/types/Product';
import { Stack, SxProps } from '@mui/material';
import { BundleProductItem } from '@/components/content/Bundle/parts/BundleProductItem';
import { BundleSelectedSize } from '@/data/Content/BundleDetailsTable';

interface BundleProductsListProps {
	components: ProductType[];
	selectedSize: BundleSelectedSize[];
	frameSx?: SxProps;
	onSizeSelect: (newSelectedSize: BundleSelectedSize) => void;
}

export const BundleProductsList: FC<BundleProductsListProps> = ({
	components,
	selectedSize,
	frameSx,
	onSizeSelect,
}) => (
	<Stack spacing={2} sx={frameSx}>
		{components.map((sku) => (
			<BundleProductItem
				key={sku.id}
				sku={sku}
				selectedSize={selectedSize}
				onSizeSelect={onSizeSelect}
			/>
		))}
	</Stack>
);
